import React, { useEffect } from 'react';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
import { userTypeOptions } from '../../utils/const';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { getProfileDetails, addOnboardDetails } from '../../redux/profile/profile.actions';
import Card from 'react-bootstrap/Card';

const Step1 = ({ history, userType, getProfileDetails, addOnboardDetails }) => {
	const { register, handleSubmit, errors } = useForm();
	const { action, state } = useStateMachine(updateAction);

	useEffect(() => {
		getProfileDetails();
	}, [getProfileDetails]);

	const onSubmit = (data) => {
		action(data);
		Object.assign(state?.data, data)
		addOnboardDetails(state?.data);
		history.push('/mycourse');
	};

	const getSelectOptionsList = (options) => {
		let result = [];
		!!options &&
			options.map(function (val, index) {
				let idAttr = val.split(" ").join("-")
				result.push(
					<div key={index} className="funkyradio-success">
						<input
							type="radio"
							name="userType"
							value={val}
							ref={register({
								required: true,
							})}
							id={idAttr}
							defaultChecked={val === (state?.data?.userType || userType)}
						/>
						<label htmlFor={idAttr}>{val}</label>
					</div>,
				);
				return true;
			});
		return result;
	};

	return (

		<form onSubmit={handleSubmit(onSubmit)} className="step-form" id="step-1">
			<div className="form-group" style={{ marginTop: '10px' }}>
				<label className="control-label" htmlFor="fullname">What is your <strong>background?</strong></label>
			</div>
			<span className="profileError">
				{errors.userType?.type === 'required' && 'Your background is required'}
			</span>

			<div className="funkyradio">{getSelectOptionsList(userTypeOptions)}</div>

			<div className=''>
				{/* <button
					aria-label="next"
					className="btn btn-primary btn-md mar-rgt"
					type="submit"
				>
					Previous
				</button> */}
				<button
					aria-label="next"
					className="btn btn-primary btn-md"
					type="submit"
				>
					Ready!
				</button>
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const { userType, userTypeOther } = state.rootReducer.profileDetails;
	return {
		userType,
		userTypeOther,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProfileDetails: () => dispatch(getProfileDetails()),
		addOnboardDetails: (obj) => dispatch(addOnboardDetails(obj))
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(Step1);
